export default "__VITE_ASSET__01c5ffaa__"